export enum ErrorOrigin {
  REGISTRATION_INVITATION_CODE = 'REGISTRATION_INVITATION_CODE',
  REGISTRATION_PASSWORD_AND_CONSENT = 'REGISTRATION_PASSWORD_AND_CONSENT',
  REGISTRATION_CONSENT = 'REGISTRATION_CONSENT',
}
